export const initialPegawaiFilter = () => ({
  type: 0,
  unit: null,
  unit2: null,
  unit3: null,
  unit4: null,
  date: new Date().toISOString().substr(0, 7),
  search: null
});
